import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import {
  toGetCertificateAwards,
} from "../../../apis/actions/photoVideos.actions";
import Loader from "../../../biblio/Loader/Loader";
import MenuItemLayout from "./MenuItemLayout";
import banner from "../../../assets/images/intern_banner.png";
import heroMobile from "../../../assets/images/intern-mob.png";
import PreviewMedia from "../../../biblio/PreviewMedia/PreviewMedia";

const CertificateAward = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { certificates, awards, loading } = useSelector(
    (state: RootState) => state.photoVideo
  );

  useEffect(() => {
    dispatch(toGetCertificateAwards());
  }, [dispatch]);

  if (loading) return <Loader />;
  return (
    <MenuItemLayout
      mobileImage={heroMobile}
      title="من نحن"
      subTitle={"الشهادات والجوائز"}
      urlImage={banner}
      className="takaful--our-story"
    >
      <PreviewMedia
        mediaItems={certificates}
        loading={loading}
        itemPerPage={3}
        isVideo={false}
        title="الشهادات"
      />
      <div className="takaful--certificate-awards">
        <PreviewMedia
          mediaItems={awards}
          loading={loading}
          itemPerPage={3}
          isVideo={false}
          title="الجوائز"
        />
      </div>
    </MenuItemLayout>
  );
};

export default CertificateAward;
